import service from "Utility/Service";
import { QueryCache, useQueryClient, useMutation, useQuery } from "react-query";
import { AxiosRequestConfig } from "axios";
// import moment from "moment";

const fetchList = async (level: string, stateCid: string) => {
  const body: any = { list: {} };

  if (level === "super_super" && stateCid !== "") body.list.cid = stateCid; // data => object
  if (level !== "super_super") body.list.cid = stateCid; // data => object

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: body,
  };
  const { data } = await service(config);

  if (level === "super_super" && stateCid !== "") return [data]; // data => object
  if (level !== "super_super") return [data]; // data => object
  return data;
};

export const useGetList = (level: string, stateCid: string) => {
  return useQuery(["get-list", stateCid], () => fetchList(level, stateCid));
  // return useQuery("get-list", () => fetchList(level, stateCid));
};

//////////////////////////////////////////////////////////////////////////////

const CreateTicket = async (props: any) => {
  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: {
      create: {
        cid: props.cid,
        url_token: "12345678901234567890123456789011",
        ticket_type: props.ticket_type,
        desc: props.description,
        url_pre_fix: props.prefix_url || null,
        new_no: props.new_no || 0,
        fix_id: props.fix_id || [],
        expire_utc: props.expiration.unix(),
      },
    },
  };
  const { data } = await service(config);
  return data;
};

export const useCreateTicket = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => CreateTicket(props), {
    onSuccess: () => queryClient.invalidateQueries("get-list"),
  });
};

//////////////////////////////////////////////////////////////////////////////

const UpdateTicket = async (props: any) => {
  let body: any = { modify: {} };

  if (props._id) {
    // update ticket from form
    body.modify._id = props._id;
    body.modify.cid = props.cid;
    body.modify.ticket = props.ticket;
    body.modify.desc = props.description;
    body.modify.url_token = props.token;
    body.modify.url_pre_fix = props.prefix_url;
    body.modify.new_no = props.new_no || 0;
    body.modify.fix_id = props.fix_id || [];
    body.modify.expire_utc = props.expiration?.unix();
    body.modify.active = props.active;
  } else {
    // update active from button
    body.modify._id = props.list._id;
    body.modify.cid = props.cid;
    body.modify.ticket = props.list.ticket;
    body.modify.desc = props.list.desc;
    body.modify.url_token = props.list.url_token;
    body.modify.url_pre_fix = props.list.url_pre_fix;
    body.modify.new_no = props.list.new_no || 0;
    body.modify.fix_id = props.list.fix_id || [];
    body.modify.expire_utc = props.list.expire_utc;

    if (props.list.active === false) body.modify.active = true;
    else body.modify.active = false;
  }

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: body,
  };
  const { data } = await service(config);
  return data;
};

export const useUpdateTicket = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => UpdateTicket(props), {
    onSuccess: () => queryClient.invalidateQueries("get-list"),
  });
};

//////////////////////////////////////////////////////////////////////////////

const deleteTicket = (props: any) => {
  const { _id } = props;

  const config: AxiosRequestConfig = {
    method: "post",
    url: "/go",
    data: { delete: { _id: _id } },
  };

  return service(config);
};

export const useDeleteTicket = () => {
  const queryClient = useQueryClient();
  return useMutation((props: any) => deleteTicket(props), {
    onSuccess: () => {
      queryClient.invalidateQueries(["get-list"]);
    },
  });
};
